module.exports = __webpack_public_path__ + "static/img/credit_score.7e49a503.png";